export const UANewbiePackEntryPoint = {
  Banner: 'banner',
  Floating: 'floating',
  DailyClaim: 'daily_claim',
  CreditsPage: 'credits_page',
} as const

export type UANewbiePackEntryPoint =
  (typeof UANewbiePackEntryPoint)[keyof typeof UANewbiePackEntryPoint]

export const UANewbiePackState = {
  NotEligible: 'not_eligible',
  NotTriggered: 'not_triggered',
  Active48h: 'active_48h',
  ActivePersistent: 'active_persistent',
  Completed: 'completed',
} as const

export type UANewbiePackState =
  (typeof UANewbiePackState)[keyof typeof UANewbiePackState]

export interface UANewbiePackTier {
  tierCode: string
  itemId: string
  purchased: boolean
  purchasable: boolean
}

export interface UANewbiePackSnapshot {
  state: UANewbiePackState
  triggerAt: string | null
  hoursSinceTrigger: number | null
  ahaShownAt: string | null
  tiers: UANewbiePackTier[]
  visibleEntryPoints: UANewbiePackEntryPoint[]
  promotionSuppression: boolean
}
